import script from "./AlarmPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AlarmPopup.vue?vue&type=script&setup=true&lang=js"

import "./AlarmPopup.vue?vue&type=style&index=0&id=6e7e7c63&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e7e7c63"]])

export default __exports__